/**
 * @deprecated legacy
 */
export namespace stringService {
  export function replaceHolder(placeholder: string, value: string, target: string) {
    return target.replace(`{${placeholder}}`, value);
  }
}
